import { render, staticRenderFns } from "./vehicleequipmenthdd.vue?vue&type=template&id=2c02674c&scoped=true"
import script from "./vehicleequipmenthdd.vue?vue&type=script&lang=js"
export * from "./vehicleequipmenthdd.vue?vue&type=script&lang=js"
import style0 from "./vehicleequipmenthdd.vue?vue&type=style&index=0&id=2c02674c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02674c",
  null
  
)

export default component.exports